import { render, staticRenderFns } from "./PlayerProductReadMoreButton.vue?vue&type=template&id=3d1f809b&scoped=true&"
import script from "./PlayerProductReadMoreButton.vue?vue&type=script&lang=js&"
export * from "./PlayerProductReadMoreButton.vue?vue&type=script&lang=js&"
import style0 from "./PlayerProductReadMoreButton.vue?vue&type=style&index=0&id=3d1f809b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f809b",
  null
  
)

export default component.exports